import React from "react";
import { Row, Col, Button, Select } from "antd";
import { NavLink, Link } from "react-router-dom";
import { general, footer } from "../../intl";
import intl from "../../pages/Home/intl";
import logo from "../../assets/logo.png";

const Option = Select.Option;

const nav = {
  contact: {
    en: "Contact",
    dk: "Kontakt"
  }
};
function List({ headline, links, language, hideContact }) {
  const list = links.map(link => {
    if (link.value[language]) {
      return (
        <li style={{ marginBottom: "5px", listStyle: "none" }}>
          <a href={link.value[language]} target="_blank">
            <span style={{ color: "#1ABC9C" }}>→</span> {link.title[language]}
          </a>
        </li>
      );
    }
    return (
      <li style={{ marginBottom: "5px", listStyle: "none" }}>
        <NavLink to={link.value}>
          <span style={{ color: "#1ABC9C" }}>→</span> {link.title[language]}
        </NavLink>
      </li>
    );
  });
  return (
    <div style={{ textAlign: "left" }}>
      <h4 style={h4Style}>{headline}</h4>
      <ul style={{ paddingLeft: "20px" }}>
        {list}
        {!hideContact && (
          <li style={{ marginBottom: "5px", listStyle: "none" }}>
            <a href="/contact">
              <span style={{ color: "#1ABC9C" }}>→</span>{" "}
              {nav.contact[language]}
            </a>
          </li>
        )}
      </ul>
    </div>
  );
}

const h4Style = { lineHeight: "35px", fontSize: "18px", color: "#fff" };
class Footer extends React.Component {
  constructor() {
    super();

    this.handleChange = this.handleChange.bind(this);
  }
  handleChange({ key, value }) {
    this.props.changeLanguage(key);
  }
  render() {
    return (
      <div>
        <Row
          style={{
            backgroundColor: "#000",
            color: "#fff",
            padding: "50px 20px"
          }}
        >
          <Col md={{ span: 4, offset: 2 }} className="footer_logo_container">
            <Link to={"/"}>
              <img alt='footer' src={logo} className="footer_logo" />
            </Link>
          </Col>
          <Col md={{ span: 16 }}>
            <Row>
              <Col md={6} sm={6} xs={12}>
                <List
                  hideContact
                  headline={footer.headline1[this.props.language]}
                  links={[
                    {
                      title: { en: "Login to test", dk: "Login til test" },
                      value: "/sign-in"
                    },
                    {
                      title: { en: "Data Protection", dk: "Databeskyttelse" },
                      value: {
                        dk:
                          "https://firebasestorage.googleapis.com/v0/b/ilead-2154a.appspot.com/o/1.%20Data%20beskyttelse.pdf?alt=media&token=efcbbdd2-0af7-4c8d-8b11-99dfbea1c614",
                        en:
                          "https://firebasestorage.googleapis.com/v0/b/ilead-2154a.appspot.com/o/1.%20DATA%20PROTECTION%20GDPR%20-%20UK.pdf?alt=media&token=06c92c3a-b850-477b-97fb-13258c6021e2"
                      }
                    },
                    {
                      title: {
                        en: "Ethical Principles",
                        dk: "Etiske Principper"
                      },
                      value: {
                        dk:
                          "https://firebasestorage.googleapis.com/v0/b/ilead-2154a.appspot.com/o/1.%20Etiske%20Principper.pdf?alt=media&token=9efba3ec-c7e6-4434-9c60-32ab1943a184",
                        en:
                          "https://firebasestorage.googleapis.com/v0/b/ilead-2154a.appspot.com/o/1.%20ETHICAL%20PRINCIPLES%20UK.pdf?alt=media&token=e14e4ab5-66dd-4bdb-868d-ed2d853ce4e3"
                      }
                    },
                    {
                      title: { en: "Privacy Policy", dk: "Fortrolighed" },
                      value: {
                        dk:
                          "https://firebasestorage.googleapis.com/v0/b/ilead-2154a.appspot.com/o/1.%20Fortrolighed.pdf?alt=media&token=9792ebfe-0ce9-4b61-bfc5-d87b22a2687e",
                        en:
                          "https://firebasestorage.googleapis.com/v0/b/ilead-2154a.appspot.com/o/1.%20PRIVACY%20POLICY%20UK.pdf?alt=media&token=3c448df7-21bb-4706-a7a4-5f21d2bbb24b"
                      }
                    }
                  ]}
                  language={this.props.language}
                />
                <div
                  style={{
                    textAlign: "left",
                    marginTop: "20px",
                    marginBottom: "20px"
                  }}
                >
                  <Select
                    labelInValue
                    defaultValue={{ key: this.props.language }}
                    value={{ key: this.props.language }}
                    style={{ width: 120 }}
                    onChange={this.handleChange}
                  >
                    <Option value="dk">Dansk</Option>
                    <Option value="en">English</Option>
                  </Select>
                </div>
              </Col>
              <Col md={6} sm={6} xs={12}>
                <List
                  headline={footer.headline2[this.props.language]}
                  links={[
                    {
                      title: { en: "Facebook", dk: "Facebook" },
                      value:
                        "https://www.facebook.com/Institute-of-Leadership-Dynamics-1131072530339933/"
                    },
                    {
                      title: { en: "LinkedIn", dk: "LinkedIn" },
                      value:
                        "https://dk.linkedin.com/company/institute-of-leadership-dynamics"
                    },
                    {
                      title: {
                        en: "Terms and Conditions",
                        dk: "Vilkår og Betingelser"
                      },
                      value: {
                        dk:
                          "https://firebasestorage.googleapis.com/v0/b/ilead-2154a.appspot.com/o/1.%20Vilka%CC%8Ar%20og%20Betingelser.pdf?alt=media&token=5cb07e87-0325-43e8-a167-3c2c88493337",
                        en:
                          "https://firebasestorage.googleapis.com/v0/b/ilead-2154a.appspot.com/o/1.%20TERMS%20AND%20CONDITIONS%20UK.pdf?alt=media&token=9112edc1-a85e-4575-81a5-242a57ede5e1"
                      }
                    }
                  ]}
                  language={this.props.language}
                />
              </Col>
              <Col md={6} sm={6} xs={24}>
                <div className="footer_mission">
                  <h4 style={h4Style}>
                    {footer.headline3[this.props.language]}
                  </h4>
                  <p
                    id="missionText"
                    style={{ color: "#8c8c8c", marginBottom: "14px" }}
                  >
                    {footer.mission[this.props.language]
                      .slice(0, 150)
                      .trim()
                      .concat("...")}
                  </p>
                  <Button href="/methodology">
                    {general.buttonReadMore[this.props.language]}
                  </Button>
                </div>
              </Col>
              <Col md={6} sm={6} xs={24}>
                <div className="footer_blog">
                  <h4 style={h4Style}>
                    {footer.headline4[this.props.language]}
                  </h4>
                  <div>
                    <Row>
                      {this.props.posts &&
                        Object.keys(this.props.posts)
                          .filter((post, index) => index < 6)
                          .map(key => (
                            <a key={key} href={`/blog/${key}`}>
                              <Col
                                key={key}
                                md={8}
                                xs={8}
                                style={{
                                  padding: " 0px 5px 0px 0px;",
                                  paddingTop: 0
                                }}
                              >
                                <div
                                  style={{
                                    width: "100%",
                                    paddingTop: "100%" /* 1:1 Aspect Ratio */,
                                    position: "relative",
                                    border: "1px solid #000",
                                    background: `url(${this.props.posts[key].coverImage}) no-repeat center center`,
                                    backgroundSize: "cover"
                                  }}
                                />
                              </Col>
                            </a>
                          ))}
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

        <div
          style={{ paddingTop: "100px", paddingBottom: "20px" }}
          className="home_header_info"
        >
          <div
            style={{
              marginLeft: "-44px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <div
              style={{
                lineHeight: "auto",
                display: "inline-block",
                textAlign: "right",
                padding: "10px 20px",
                borderRight: "1px solid #1ABC9C",
                color: "#FFF"
              }}
            >
              Institute of Leadership Dynamics A/S
              <br />
              CVR 26 59 57 38
              <br />
              {intl.contactinfo.location[this.props.language]}
            </div>
            <div
              style={{
                lineHeight: "auto",
                display: "inline-block",
                padding: "10px 50px",
                color: "#FFF"
              }}
            >
              <span style={{ color: "#1abc9c  " }}>
                {intl.contactinfo.openHours[this.props.language]}
              </span>
              <br />
              24/7/364
              <br />
            </div>
            <div
              style={{
                lineHeight: "auto",
                display: "inline-block",
                textAlign: "left",
                padding: "10px 20px",
                borderLeft: "1px solid #1ABC9C",
                color: "#FFF"
              }}
            >
              {intl.contactinfo.contact[this.props.language]}
              <br />
              <a href="mailto:info@leadershipdynamic.net">
                info@leadershipdynamic.net
              </a>{" "}
              <br />
              +45 40 18 44 34
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js